var m;

m = require('mithril');

module.exports = function(store) {
  return function(next) {
    return function(action) {
      var result;
      m.startComputation();
      result = next(action);
      m.endComputation();
      return result;
    };
  };
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3N0YXRlL1JlZHJhd01pZGRsZXdhcmUuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3dvcmsvc3JjL3N0YXRlL1JlZHJhd01pZGRsZXdhcmUuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUVKLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUMsS0FBRDtTQUFXLFNBQUMsSUFBRDtXQUFVLFNBQUMsTUFBRDtBQUVyQyxVQUFBO01BQUEsQ0FBQyxDQUFDLGdCQUFGLENBQUE7TUFDQSxNQUFBLEdBQVMsSUFBQSxDQUFLLE1BQUw7TUFDVCxDQUFDLENBQUMsY0FBRixDQUFBO2FBRUE7SUFOcUM7RUFBVjtBQUFYIn0=
